export default "__VITE_ASSET__DqMvIbKK__"